
import { GameModel } from "@nolimitcity/slot-game/bin/model/GameModel";
import { ApiPlugin } from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import { APIEvent } from '@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem';
import { APIFeatureBetEventData } from '@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData';
import { InitData } from "../data/InitData";
import { GameData } from "../data/GameData";
import { BaseServerData } from "./IData";

export class BaseModel extends GameModel<InitData, GameData> {
    public static buyFeatureName: string = '';
    public static featureBuy: boolean = false;
    private static api: ApiPlugin;

    constructor(_api: ApiPlugin) {
        super(_api);

        BaseModel.api = _api;
        
        this.gameData = new GameData();
        this.initData = new InitData();

        this.applyBelowStakeCheck(_api);
    }
    
    private applyBelowStakeCheck(api: ApiPlugin): void {
        
        api.events.once('featureName', (data: string) => {
            BaseModel.buyFeatureName = data;
        });

        api.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            this.onBet(betData);
        });

        api.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            this.onBet(betData);
        });

        this.gameData.Win.isWinBelowStake = () => this.isWinBelowStake;
        this.initData.Win.isWinBelowStake = () => this.isWinBelowStake;

        this.gameData.Win.isIndiviWinBelowStake = () => this.isIndiviWinBelowStake;
        this.initData.Win.isIndiviWinBelowStake = () => this.isIndiviWinBelowStake;
    }

    private onBet(betData: APIFeatureBetEventData): void {
        if(betData.type === "normalBet"){
            BaseModel.buyFeatureName = "";
            BaseModel.featureBuy = false;
        }else{
            for (let index: number = 0; index < this.initData.featureBuyTimesBetValue.length; index++) {
                if (this.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    BaseModel.buyFeatureName = betData.featureName;
                    BaseModel.featureBuy = !!betData.playerInteraction;
                    break;
                }
            }
        }
    }

    private get getAccumulatedRoundWin(): number {
        return this.gameData?.Win.totalWin || this.initData.Win.totalWin;
    }

    public get isWinBelowStake(): boolean {
        return (
            BaseModel.api.gameClientConfiguration.belowStakeWinRestriction &&
            this.getAccumulatedRoundWin <= this.getBuyFeaturePrice
        );
    }

    public get isWinBelowStakeAllNoRestriction(): boolean {
        return this.getAccumulatedRoundWin <= this.getBuyFeaturePrice;
    }

    public get isIndiviWinBelowStake(): boolean {
        return BaseModel.api.gameClientConfiguration.belowStakeWinRestriction && this.gameData.Win.winRatio <= 1
    }

    public get getBuyFeaturePrice(): number {
        
        const betLevel: string = BaseModel.api.freeBets.hasFreeBets()
            ? BaseModel.api.freeBets.getBet()
            : BaseModel.api.betLevel.getLevel();
        let price: number = this.gameData?.Win.playedBetValue || parseFloat(betLevel);

        if (BaseModel.buyFeatureName) {
            for (let index: number = 0; index < this.initData.featureBuyTimesBetValue.length; index++) {
                if (this.initData.featureBuyTimesBetValue[index].name === BaseModel.buyFeatureName) {
                    price *= this.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    protected onInit(data: any): void {
        this.data = data;
        this.initData.setData(data);
        this.gameData.setData(data);
    }

    protected onGame(data: any): void {
        this.data = data;
        this.gameData.setData(data);
    }
}